'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');
const button_style = require('../Button/button.style.js');
const link = require('../Link/link.js');

var linkBlue = universal_color.linkBlue,
  mlbWhite = universal_color.mlbWhite,
  mlbGrey2 = universal_color.mlbGrey2,
  mlbGrey7 = universal_color.mlbGrey7;
var SpotTagContainer = styled__default.div.withConfig({
  displayName: "spotTagstyle__SpotTagContainer",
  componentId: "sc-1mzqt5k-0"
})(["display:flex;align-items:center;", "{margin-left:0.5rem;padding-left:15px;padding-right:15px;}"], button_style.StyledButton);
var SpotLink = styled__default(link).withConfig({
  displayName: "spotTagstyle__SpotLink",
  componentId: "sc-1mzqt5k-1"
})([""]);
var SpotTagCopy = styled__default.div.withConfig({
  displayName: "spotTagstyle__SpotTagCopy",
  componentId: "sc-1mzqt5k-2"
})(["", ";"], function (_ref) {
  var isMultiline = _ref.isMultiline,
    isSpotTile = _ref.isSpotTile;
  if (isSpotTile) {
    return 'padding-top: 8px;';
  } else if (isMultiline) {
    return 'padding-left: 10px;';
  } else {
    return 'padding-left: 0.5rem;';
  }
});
var SpotWrapper = styled__default.div.withConfig({
  displayName: "spotTagstyle__SpotWrapper",
  componentId: "sc-1mzqt5k-3"
})(["display:flex;align-items:center;text-decoration:none;"]);
var TagName = styled__default.div.withConfig({
  displayName: "spotTagstyle__TagName",
  componentId: "sc-1mzqt5k-4"
})(["font-size:", "px;font-weight:bold;color:", ";padding-bottom:", "px;padding-top:", "px;white-space:nowrap;"], function (_ref2) {
  var fontsizeOverride = _ref2.fontsizeOverride;
  return fontsizeOverride || 16;
}, function (_ref3) {
  var dark = _ref3.dark;
  return dark ? mlbWhite : mlbGrey7;
}, function (_ref4) {
  var isSpotTile = _ref4.isSpotTile;
  return isSpotTile ? 0.5 : 1;
}, function (_ref5) {
  var isSpotTile = _ref5.isSpotTile;
  return isSpotTile ? 0.5 : 1;
});
var SuperTagName = styled__default(TagName).withConfig({
  displayName: "spotTagstyle__SuperTagName",
  componentId: "sc-1mzqt5k-5"
})(["font-size:17px;font-weight:normal;"]);
var SpotTile = styled__default.button.withConfig({
  displayName: "spotTagstyle__SpotTile",
  componentId: "sc-1mzqt5k-6"
})(["background:none;border-radius:8px;cursor:pointer;flex-direction:column;justify-content:center;padding:0;width:114px;height:110px;", ";", ",", "{font-size:13px;}"], function (_ref6) {
  var active = _ref6.active,
    activeBorderColor = _ref6.activeBorderColor;
  if (active) {
    return "border: 3px solid ".concat(activeBorderColor || linkBlue, ";");
  } else {
    return "border: 1px solid ".concat(mlbGrey2, ";");
  }
}, SuperTagName, TagName);

exports.SpotLink = SpotLink;
exports.SpotTagContainer = SpotTagContainer;
exports.SpotTagCopy = SpotTagCopy;
exports.SpotTile = SpotTile;
exports.SpotWrapper = SpotWrapper;
exports.SuperTagName = SuperTagName;
exports.TagName = TagName;
